/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.controllers', [])

.controller('SherpaController', ['$scope', function($scope) {

    $scope.sherpa = {

    };

}]);